export default defineNuxtRouteMiddleware((to) => {
  // //////////////////////////////////////////////////////////////////
  // Auth Route Middleware - Cookie Must Exist or Redirect to Login
  // //////////////////////////////////////////////////////////////////
  // const authCookie = useCookie('user')
  // console.log('Auth Middleware Cookie', authCookie.value)
  const { $auth } = useNuxtApp()
  const auth = $auth ? $auth.currentUser : null
  const userCookie = useCookie('user', { maxAge: 180 * 60 })

  try {
    // If Oauth Redirect
    if (to.name === 'oauth') return

    if (to.name !== 'login' && !auth && !userCookie.value) return navigateTo('/login')

    if (to.name === 'login' && auth) return navigateTo('/')
  } catch (error) {
    console.log('Routing Errors')
  }

  // If Valid Route - Save Last Path to Local Storage
  // localStorage.setItem('lastPath', to.path) // Without Nuxt Storage
  useSetLocalStorage('lastPath', to.path)
})
